import React, {FunctionComponent} from 'react';
import styles from './style.module.scss';

const Loader: FunctionComponent = () => {
    return <div className={styles.loader}/>;
};

export default React.memo(Loader);
